module.exports = __webpack_public_path__ + "img/PowerOn.c01f1fbe.png";